var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{staticClass:"px-3",attrs:{"column":_vm.$vuetify.breakpoint.xsOnly,"justify-center":"","align-center":"","wrap":""}},_vm._l((Object.entries(_vm.extraActions)),function(ref){
var key = ref[0];
var extra = ref[1];
return _c('Button',{key:extra,staticClass:"small",attrs:{"loading":_vm.loading},on:{"click":function($event){return _vm.sendExtra(key)}}},[_vm._v(_vm._s(extra))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }